import { render, staticRenderFns } from "./OnboardingChooseDomainModal.vue?vue&type=template&id=2531e6ce&scoped=true"
import script from "./OnboardingChooseDomainModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseDomainModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseDomainModal.vue?vue&type=style&index=0&id=2531e6ce&prod&lang=scss&scoped=true"
import style1 from "./OnboardingChooseDomainModal.vue?vue&type=style&index=1&id=2531e6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531e6ce",
  null
  
)

export default component.exports